var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "yoyo-container mx-auto min-h-screen pb-[env(safe-area-inset-bottom)] bg-gray-50",
    },
    [
      _c("navBar", {
        attrs: { title: _vm.$t("orderDetail.title"), showBack: true },
      }),
      _c("div", { staticClass: "px-4 py-4 space-y-4 detail" }, [
        _c(
          "div",
          {
            class: [
              "bg-white rounded-lg px-4 py-2 text-left text-lg font-bold flex items-center ",
              _vm.getStatusClass,
            ],
          },
          [_vm._v(" " + _vm._s(_vm.getStatusText) + " ")]
        ),
        _c(
          "div",
          { staticClass: "bg-white rounded-lg overflow-hidden" },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center px-4 py-2 border-b border-gray-100",
              },
              [
                _c("div", { staticClass: "w-2 h-4 bg-orange-500 mr-2" }),
                _c("span", { staticClass: "text-gray-800 font-medium" }, [
                  _vm._v(_vm._s(_vm.$t("orderDetail.productInfo"))),
                ]),
              ]
            ),
            _vm._l(_vm.orderDetail.items, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass:
                    "flex items-center px-4 py-2 border-b border-gray-100",
                  class:
                    index === _vm.orderDetail.items.length - 1
                      ? "border-b-0"
                      : "",
                },
                [
                  _c("img", {
                    staticClass: "w-12 h-12 rounded-lg",
                    attrs: { src: _vm.imageBaseUrl + item.picUrl, alt: "" },
                  }),
                  _c("div", { staticClass: "ml-3 flex-1" }, [
                    _c(
                      "div",
                      { staticClass: "flex items-center justify-between" },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(item.spuType) +
                              " " +
                              _vm._s(_vm.isZh ? item.spuPlace : item.spuPlaceEn)
                          ),
                        ]),
                        _c("span", [
                          _vm._v("RM " + _vm._s(_vm.formatToYuan(item.price))),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "flex items-center justify-between" },
                      [
                        _c("span", { staticClass: "mr-1" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.isZh
                                  ? item.dayValue.name +
                                      _vm.$t("products.day") +
                                      " " +
                                      item.packageValue.name
                                  : item.dayValue.nameEn +
                                      (item.dayValue.nameEn > 1
                                        ? _vm.$t("products.days")
                                        : _vm.$t("products.day")) +
                                      " " +
                                      item.packageValue.nameEn
                              ) +
                              " "
                          ),
                        ]),
                        _c("span", [_vm._v("x" + _vm._s(item.count))]),
                      ]
                    ),
                  ]),
                ]
              )
            }),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "bg-white rounded-lg overflow-hidden" },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center px-4 py-2 border-b border-gray-100",
              },
              [
                _c("div", { staticClass: "w-2 h-4 bg-orange-500 mr-2" }),
                _c("span", { staticClass: "text-gray-800 font-medium" }, [
                  _vm._v(_vm._s(_vm.$t("orderDetail.orderAmount"))),
                ]),
              ]
            ),
            _c("van-cell", {
              attrs: {
                title: _vm.$t("orderDetail.shippingFee"),
                value: `RM ${_vm.formatToYuan(_vm.orderDetail.deliveryPrice)}`,
              },
            }),
            _c("van-cell", {
              attrs: {
                title: _vm.$t("orderDetail.productAmount"),
                value: `RM ${_vm.formatToYuan(_vm.orderDetail.totalPrice)}`,
              },
            }),
            _c("van-cell", {
              attrs: {
                title: _vm.$t("orderDetail.yoyoCoinDiscount"),
                value: `-RM ${_vm.formatToYuan(_vm.orderDetail.pointPrice)}`,
                "value-class": "text-[#ff7a00]",
              },
            }),
            _c("van-cell", {
              attrs: {
                title: _vm.$t("orderDetail.couponDiscount"),
                value: `-RM ${_vm.formatToYuan(_vm.orderDetail.couponPrice)}`,
                "value-class": "text-[#ff7a00]",
              },
            }),
            _c("van-cell", {
              attrs: {
                title: _vm.$t("orderDetail.actualAmount"),
                value: `RM ${_vm.formatToYuan(_vm.orderDetail.payPrice)}`,
                "title-class": "font-medium",
                "value-class": "text-[#ff7a00] font-medium text-lg",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "bg-white rounded-lg overflow-hidden" },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center px-4 py-2 border-b border-gray-100",
              },
              [
                _c("div", { staticClass: "w-2 h-4 bg-orange-500 mr-2" }),
                _c("span", { staticClass: "text-gray-800 font-medium" }, [
                  _vm._v(_vm._s(_vm.$t("orderDetail.receiverInfo"))),
                ]),
              ]
            ),
            _vm.showReceiverInfo
              ? _c(
                  "div",
                  [
                    _c("van-cell", {
                      attrs: {
                        title: _vm.$t("orderDetail.receiverName"),
                        value: _vm.orderDetail.receiverName,
                      },
                    }),
                    _c("van-cell", {
                      attrs: {
                        title: _vm.$t("orderDetail.receiverPhone"),
                        value: _vm.orderDetail.receiverMobile,
                      },
                    }),
                    _c("van-cell", {
                      attrs: {
                        title: _vm.$t("orderDetail.receiverAddress"),
                        value:
                          _vm.orderDetail.receiverCity +
                          "" +
                          _vm.orderDetail.receiverCountry +
                          "" +
                          _vm.orderDetail.receiverDetailAddress,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c("van-cell", {
              attrs: {
                title: _vm.$t("orderDetail.email"),
                value: _vm.orderDetail.email,
              },
            }),
          ],
          1
        ),
        _vm.orderDetail.logisticsName ||
        _vm.orderDetail.logisticsNo ||
        _vm.orderDetail.deliveryTime
          ? _c(
              "div",
              { staticClass: "bg-white rounded-lg overflow-hidden" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center px-4 py-2 border-b border-gray-100",
                  },
                  [
                    _c("div", { staticClass: "w-2 h-4 bg-orange-500 mr-2" }),
                    _c("span", { staticClass: "text-gray-800 font-medium" }, [
                      _vm._v(_vm._s(_vm.$t("orderDetail.logisticsInfo"))),
                    ]),
                  ]
                ),
                _c("van-cell", {
                  attrs: {
                    title: _vm.$t("orderDetail.logisticsCompany"),
                    value: _vm.orderDetail.logisticsName,
                  },
                }),
                _c("van-cell", {
                  attrs: {
                    title: _vm.$t("orderDetail.trackingNumber"),
                    value: _vm.orderDetail.logisticsNo,
                  },
                }),
                _c("van-cell", {
                  attrs: {
                    title: _vm.$t("orderDetail.shippingTime"),
                    value: _vm.orderDetail.deliveryTime,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "bg-white rounded-lg overflow-hidden" },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center px-4 py-2 border-b border-gray-100",
              },
              [
                _c("div", { staticClass: "w-2 h-4 bg-orange-500 mr-2" }),
                _c("span", { staticClass: "text-gray-800 font-medium" }, [
                  _vm._v(_vm._s(_vm.$t("orderDetail.orderInfo"))),
                ]),
              ]
            ),
            _c("van-cell", {
              attrs: {
                title: _vm.$t("orderDetail.orderNumber"),
                value: _vm.orderDetail.id,
              },
            }),
            _c("van-cell", {
              attrs: {
                title: _vm.$t("orderDetail.serialNumber"),
                value: _vm.orderDetail.no,
              },
            }),
            _c("van-cell", {
              attrs: {
                title: _vm.$t("orderDetail.createTime"),
                value: _vm.formatTime(_vm.orderDetail.createTime),
              },
            }),
            _vm.orderDetail.payTime
              ? _c("van-cell", {
                  attrs: {
                    title: _vm.$t("orderDetail.payTime"),
                    value: _vm.formatTime(_vm.orderDetail.payTime),
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm.orderDetail.status == 0
        ? _c(
            "div",
            { staticClass: "flex flex-col justify-center items-center" },
            [
              _c("PaymentMethod", { ref: "paymentMethod" }),
              _c(
                "van-button",
                {
                  staticClass: "w-44 h-9 rounded-xl mt-4 mb-10",
                  attrs: { type: "danger", color: "#ff7a00" },
                  on: { click: _vm.handlePay },
                },
                [_vm._v(" " + _vm._s(_vm.$t("orderDetail.rePay")) + " ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }